import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { AuthGuard } from './components/auth/AuthGuard';
import { LoginPage } from './components/auth/LoginPage';
import { Layout } from './components/admin/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { ConversationsPage } from './pages/ConversationsPage';
import { ConversationDetailPage } from './pages/ConversationDetailPage';
import { UsersPage } from './pages/UsersPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { SettingsPage } from './pages/SettingsPage';
import { CannedResponsesPage } from './pages/CannedResponsesPage';
import { ContactsPage } from './pages/ContactsPage';
import { ContactDetailPage } from './pages/ContactDetailPage';
import { AutomationRulesPage } from './pages/AutomationRulesPage';
import { SlaPage } from './pages/SlaPage';
import { WebhooksPage } from './pages/WebhooksPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { ArticleEditorPage } from './pages/ArticleEditorPage';
import { HelpCenterPage } from './pages/HelpCenterPage';
import { ChannelsPage } from './pages/ChannelsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/help/:orgSlug" element={<HelpCenterRoute />} />
          <Route
            path="/"
            element={
              <AuthGuard>
                <Layout />
              </AuthGuard>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="conversations" element={<ConversationsPage />} />
            <Route path="conversations/:id" element={<ConversationDetailPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="contacts/:id" element={<ContactDetailPage />} />
            <Route path="canned-responses" element={<CannedResponsesPage />} />
            <Route path="automations" element={<AutomationRulesPage />} />
            <Route path="sla-policies" element={<SlaPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="organizations" element={<OrganizationsPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="documents/edit/:id" element={<ArticleEditorPage />} />
            <Route path="webhooks" element={<WebhooksPage />} />
            <Route path="audit-log" element={<AuditLogPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="channels" element={<ChannelsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function HelpCenterRoute() {
  const { orgSlug } = useParams<{ orgSlug: string }>();
  return <HelpCenterPage organizationSlug={orgSlug || ''} />;
}

export default App;
